import React, { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { FiArrowLeft } from 'react-icons/fi';
import PageLayout from '../../components/base/PageLayout';
import AccountSelection from '../../components/broker/AccountSelection';

const AccountSelectionPage = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const brokerIntegration = location.state?.brokerIntegration;
  const brokerType = location.state?.brokerType;
  const broker = brokerIntegration?.broker || brokerType;

  useEffect(() => {
    if (!broker) {
      console.log('❌ No broker specified, redirecting to broker integrations');
      navigate('/broker-integrations');
      return;
    }
  }, [broker, navigate]);

  const handleAccountSelected = (accountId, accountData) => {
    console.log('✅ Account selected:', accountId);
    // Navigate to dashboard or wherever appropriate after selection
    navigate('/dashboard', {
      state: {
        accountSelected: true,
        broker: broker,
        accountId
      }
    });
  };

  const handleCancel = () => {
    navigate(-1); // Go back to previous page
  };

  if (!broker) {
    return null;
  }

  const brokerDisplayName = broker?.charAt(0).toUpperCase() + broker?.slice(1);

  return (
    <PageLayout>
      <div className="max-w-4xl mx-auto px-4 py-8">
        {/* Back button */}
        <button
          onClick={handleCancel}
          className="flex items-center gap-2 text-gray-600 hover:text-gray-900 mb-6 transition-colors"
        >
          <FiArrowLeft className="w-4 h-4" />
          <span>Back</span>
        </button>

        {/* Page title */}
        <div className="mb-8">
          <h1 className="text-2xl font-bold text-gray-900 mb-2">
            {brokerDisplayName} Account Setup
          </h1>
          <p className="text-gray-600">
            Complete your broker integration by selecting a trading account
          </p>
        </div>

        {/* Main content card */}
        <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
          <AccountSelection
            broker={broker}
            onAccountSelected={handleAccountSelected}
            onCancel={handleCancel}
          />
        </div>
      </div>
    </PageLayout>
  );
};

export default AccountSelectionPage;